import actionCreatorFactory from 'typescript-fsa';
const actionCreator = actionCreatorFactory('@@TapPlatform/auth');
export const tokenRetrieved = actionCreator('TOKEN_RETRIEVED');
export const tokenRenewed = actionCreator('TOKEN_RENEWED');
export const loginDone = actionCreator('LOGIN_DONE');
export const logout = actionCreator.async('LOGOUT');
export const setAuthProps = actionCreator('SET_AUTH_PROPS');
//# sourceMappingURL=auth.actions.js.map